/* @flow */
import React, {Component, Fragment} from 'react';
import {DropdownControlled} from '@homeaway/react-dropdown';
import MoreFiltersPanel from '../MoreFiltersPanel/MoreFiltersPanel';
import FilteredCountDataProvider from '../FilteredCountDataProvider/FilteredCountDataProvider';
import {filterCount} from '../../utils/filterCount';
import {HA_SERP_DESKTOP_FILTER_BTN} from '../../abacus/experiments';
import {connect} from 'react-redux';
import Icon from '../Icon/Icon';
import {FormattedMessage} from 'react-intl';
import classnames from 'classnames';

import type {SearchParamsType} from '../../reducers/searchParams';
import type {State as ReduxState} from '../../reducers/index';

import type {CallbackProps as FilteredCountDataShape} from '../FilteredCountDataProvider/FilteredCountDataProvider';

type OwnProps = {
    onCancel: () => void,
    toggleDropdown: () => void,
    open: boolean,
    onApplyFilters: (void) => void,
    onInputParamsRangeFilterChange: (SearchParamsType) => void,
    searchResultsLoading: boolean,
    topBannersHeight: number
};

type StateProps = {
    desktopFilterBtnTestOn: boolean,
    numFiltersPanel: number
};

type Props = OwnProps & StateProps;

const MORE_FILTERS_ID = 'moreFilters';

export class MoreFiltersPanelDropdown extends Component<Props> {
    renderMoreFiltersPanel = ({
        filterGroups,
        resultsCount
    }: FilteredCountDataShape) => {
        const {
            onApplyFilters,
            onInputParamsRangeFilterChange,
            open,
            onCancel
        } = this.props;

        return (
            <MoreFiltersPanel
                onApplyFilters={onApplyFilters}
                filterGroups={filterGroups}
                resultsCount={resultsCount}
                onInputParamsRangeFilterChange={onInputParamsRangeFilterChange}
                onCancel={onCancel}
                isVisible={open}
            />
        );
    };

    renderButton = (includeIcon: boolean) => {
        return (
            <Fragment>
                {includeIcon && <Icon name="sliders" color={'link-color'} />}
                <FormattedMessage
                    id="moreFiltersLabel"
                    defaultMessage="More Filters"
                >
                    {(txt) =>
                        `${String(txt)} ${filterCount(
                            this.props.numFiltersPanel
                        )}`
                    }
                </FormattedMessage>
            </Fragment>
        );
    };

    render = () => {
        const {
            renderMoreFiltersPanel,
            props: {
                open,
                onApplyFilters,
                toggleDropdown,
                searchResultsLoading,
                desktopFilterBtnTestOn
            }
        } = this;

        return (
            <DropdownControlled
                id={MORE_FILTERS_ID}
                label={this.renderButton(desktopFilterBtnTestOn)}
                onDropdownClick={toggleDropdown}
                onBlur={onApplyFilters}
                onTouch={onApplyFilters}
                open={open}
                noArrow={desktopFilterBtnTestOn}
                className={classnames({
                    HA_SERP_DESKTOP_FILTER_BTN: desktopFilterBtnTestOn
                })}
            >
                <FilteredCountDataProvider
                    children={renderMoreFiltersPanel}
                    searchResultsLoading={searchResultsLoading}
                    open={open}
                />
            </DropdownControlled>
        );
    };
}

const mapStateToProps = ({
    abacus,
    searchParams: {numFiltersPanel}
}: ReduxState) => ({
    desktopFilterBtnTestOn: !!(abacus[HA_SERP_DESKTOP_FILTER_BTN] || {}).value,
    numFiltersPanel
});

export default connect(
    mapStateToProps,
    null
)(MoreFiltersPanelDropdown);
